// How long a message may wait in the review, as people read it: "1 minuto", "90 segundos", "2 minutos"
export const windowLabel = (seconds) =>
  seconds % 60 === 0 ? `${seconds / 60} minuto${seconds === 60 ? '' : 's'}` : `${seconds} segundos`;
